var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHuile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 100",
    style: {
      enableBackground: "new 0 0 125 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE7203;}\r\n\t.st1{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.7,66.5c-0.9,0-1.6,0.7-1.6,1.3s0.7,1.3,1.6,1.3H96c0.9,0,1.6-0.7,1.6-1.3s-0.7-1.3-1.6-1.3H42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.8,19.7c4,0,6.7,1.6,7.6,4.5c1.1,4,16.1,49.1,17.6,52.6c0.2,0.4,0.4,0.9,0.7,1.3c0.9,2.5,2,5.6,8,5.6h40.1 c3.1,0,6.7-0.7,8.9-5.4c2.5-5.4,15.8-33,16.7-34.8c0.9-1.8,2.2-5.4,0.4-8.3c-0.9-1.6-2.9-3.1-7.4-3.1H42.4c-0.9,0-1.6,0.7-1.6,1.6 s0.7,1.6,1.6,1.6h21V50H39.8c-0.2,0-0.4,0-0.7,0l-0.9,0.2L38,49.3c-3.6-10.7-7.8-23.6-8.5-26.1c-1.1-4.2-5.1-6.9-10.5-6.9H6.8 c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6h12V19.7z M88.6,35.5h23c1.8,0,3.8,0.2,4.7,1.6c0.9,1.6,0,4-0.4,5.1 c-0.2,0.4-1.6,3.1-3.8,7.6l-0.4,0.7l-0.9-0.2c-0.2,0-0.4,0-0.4,0H88.6L88.6,35.5L88.6,35.5z M88.6,53.1h21.6l-0.7,1.6 c-4.2,8.9-9.4,19.6-10.7,22.3c-1.6,3.1-3.3,3.6-6.2,3.6c-0.2,0-0.4,0-0.7,0h-3.6V53.1H88.6z M66.3,35.5h19.4v14.7H66.3V35.5z  M66.3,53.1h19.4v27.7H66.3V53.1z M63.4,53.1v27.7H52.7c-3.6,0-4.2-0.9-5.1-3.6l0,0c-0.2-0.4-0.4-1.1-0.7-1.8 c-0.7-1.6-5.4-15.2-7.1-21l-0.4-1.6h24.1V53.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuile);
export default __webpack_public_path__ + "static/media/huile.dd1c663dae633dc1ceb4f18eb8870dd8.svg";
export { ForwardRef as ReactComponent };